import { AST } from '@handlebars/parser';
import {
  HANDLEBARS_BOOLEAN_FALSE,
  HANDLEBARS_BOOLEAN_TRUE,
  HANDLEBARS_NULL,
  HANDLEBARS_UNDEFINED,
} from './constants';
import {
  isBooleanLiteral,
  isNullLiteral,
  isNumberLiteral,
  isStringLiteral,
  isUndefinedLiteral,
} from './utils';

/**
 * Utility class for converting `AST.Literal` to a Handlebars template string
 */
export class LiteralSerializer {
  /**
   * Serializes any type of `AST.Literal` into a Handlebars template sting
   */
  static serialize = (literal: AST.Literal) => {
    if (isStringLiteral(literal)) return LiteralSerializer.serializeStringLiteral(literal);
    if (isNumberLiteral(literal)) return LiteralSerializer.serializeNumberLiteral(literal);
    if (isBooleanLiteral(literal)) return LiteralSerializer.serializeBooleanLiteral(literal);
    if (isNullLiteral(literal)) return LiteralSerializer.serializeNullLiteral();
    if (isUndefinedLiteral(literal)) return LiteralSerializer.serializeUndefinedLiteral();

    throw new Error('Unable to parse literal');
  };

  /**
   * Serializes `AST.BooleanLiteral` into a Handlebars template sting
   */
  private static serializeBooleanLiteral = (literal: AST.BooleanLiteral) =>
    literal.value ? HANDLEBARS_BOOLEAN_TRUE : HANDLEBARS_BOOLEAN_FALSE;

  /**
   * Serializes `AST.NullLiteral` into a Handlebars template sting
   */
  private static serializeNullLiteral = () => HANDLEBARS_NULL;

  /**
   * Serializes `AST.NumberLiteral` into a Handlebars template sting
   */
  private static serializeNumberLiteral = (literal: AST.NumberLiteral) =>
    literal.value.toString(10);

  /**
   * Serializes `AST.StringLiteral` into a Handlebars template sting
   */
  private static serializeStringLiteral = (literal: AST.StringLiteral) => `"${literal.value}"`;

  /**
   * Serializes `AST.UndefinedLiteral` into a Handlebars template sting
   */
  private static serializeUndefinedLiteral = () => HANDLEBARS_UNDEFINED;
}
